import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import CustomRadioGroup from '../elements/Component.RadioGroup';

class SetWorkflow extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      workflow: props.parameters.workflowDefault
    }
  }

  updateWorkflow = (e) => {
    // console.log(e.target.value);
    this.setState({workflow: e.target.value});
    this.props.updateParameters({workflowDefault: e.target.value});
  }

  render(){
    // console.log(this.props);
    return(
       <div className="step-outter-wrapper">
        <div className="step-inner-wrapper">
          <div className="step-title-style">
            <h3>Select Workflow</h3>
          </div>

          <div css={css`
            width: 100%;
            padding: 40px;
          `}>
          <CustomRadioGroup 
            options={this.props.workflowOptions}
            onChange={this.updateWorkflow} 
            defaultValue={this.props.parameters.workflowDefault}
            value={this.state.workflow}
            disabled={false} />
          </div>
        </div>
      </div>
    )
  }
}

export default SetWorkflow;